// extracted by mini-css-extract-plugin
export var education = "style-module--education--407d3";
export var education__block = "style-module--education__block--e2ec8";
export var education__blockText = "style-module--education__block-text--85760";
export var education__blocks = "style-module--education__blocks--597db";
export var education__title = "style-module--education__title--5ee24";